import {
    Box,
    FormControl,
    FormHelperText,
    MenuItem,
    Select,
    Typography,
} from "@mui/material"
import PropTypes from "prop-types"
import React, {useEffect} from "react"
import InfoIcon from "../../components/general/infoIcon"

export const widgetChildSelectPrototype = [
    {
        key: "path",
        type: "STRING",
        label: "Pfad",
        size: 6,
    },
    {
        key: "labelPath",
        type: "STRING",
        label: "Display Prop",
        size: 6,
    },
    {
        key: "defaultLabel",
        type: "STRING",
        label: "Default-Wert (matched gegen 'Display Prop' der Optionen)",
        size: 6,
    },
]

const ChildrenSelectWidget = ({
    widget,
    value,
    getDataFromPointer,
    onValueChange,
    disabled,
    triggerAction,
}) => {
    const options = widget.path ? getDataFromPointer(widget.path) : []
    const needDefaultToBeSet = !(
        value ||
        !widget?.labelPath ||
        !widget?.defaultLabel
    )
    useEffect(() => {
        if (needDefaultToBeSet) {
            const match = options?.find?.(
                (opt) => opt?.[widget.labelPath] === widget.defaultLabel,
            )
            if (match) onValueChange(match)
        }
    }, [needDefaultToBeSet, options?.length])

    const onSelectChange = (event) => {
        const newValue = event.target.value
        onValueChange(newValue)
    }
    
    return (
        <FormControl fullWidth>
            {(widget.text || widget.infotext) && (
                <Box
                    display="flex"
                    alignItems="center"
                    gap={1}>
                    {widget.text && (
                        <Typography className={disabled ? "disabled" : ""}>
                            {widget.text}
                        </Typography>
                    )}

                    {widget.infotext && <InfoIcon infoText={widget.infotext} />}
                </Box>
            )}
            <Select
                id={widget.id}
                value={value}
                onChange={onSelectChange}
                className={widget.className}
                disabled={disabled}
                renderValue={(item) => item?.label ?? ""}>
                {Array.isArray(options) &&
                    options.map((option, index) => (
                        <MenuItem
                            key={index}
                            value={option}
                            disabled={option?.disabled}>
                            {widget?.labelPath
                                ? option?.[widget?.labelPath]
                                : index + 1}
                        </MenuItem>
                    ))}
            </Select>
            {widget.helperText && (
                <FormHelperText>{widget.helperText}</FormHelperText>
            )}
        </FormControl>
    )
}

ChildrenSelectWidget.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
}

export default ChildrenSelectWidget
